var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMenuWhitepaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.92193,
    y: 1.92193,
    width: 46.1562,
    height: 46.1562,
    rx: 6.07807,
    stroke: "white",
    strokeWidth: 2.15615
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.246 37.9882C15.7189 37.9882 15.2578 37.7905 14.8625 37.3953C14.4672 37 14.2695 36.5388 14.2695 36.0117V13.6117C14.2695 13.0847 14.4672 12.6235 14.8625 12.2282C15.2578 11.8329 15.7189 11.6353 16.246 11.6353H28.1378L35.3519 18.8494V36.0117C35.3519 36.5388 35.1542 37 34.7589 37.3953C34.3636 37.7905 33.9025 37.9882 33.3754 37.9882H16.246ZM27.1495 19.7388V13.6117H16.246V36.0117H33.3754V19.7388H27.1495Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuWhitepaper);
export default __webpack_public_path__ + "static/media/icon_menu_whitepaper.4509499cdf3c2395e95f00759deb7c54.svg";
export { ForwardRef as ReactComponent };